import {
  ApprovalEntityActionPayload,
  DesignationApprovers,
  DesignationApproversData,
  EntityActionResponse,
  EntityAllowedActionsResponse,
  EntityDetailsResponse,
  RequestAccessPayload,
  RequestAccessResponse,
} from './types';
import {
  getDesignationApproversApi,
  getEntityActionsApi,
  getEntityDetailsApi,
  performApprovalEntityActionApi,
  requestAccessApi,
} from '../../../apiRoutes';
import { fetch } from '../../mainhome/Utils/apiClient';
import { getErrorMessage, showToast } from '../../mainhome/Utils/helpers';

export const designationApproverInitialState: DesignationApproversData = {
  designations: [],
  approvers: [],
};

export const getDesignationApprovers =
  async (): Promise<DesignationApproversData> => {
    try {
      const response = (await fetch(
        getDesignationApproversApi,
      )) as DesignationApprovers;
      return response.data;
    } catch (error) {
      showToast(getErrorMessage(error), false);
      return designationApproverInitialState;
    }
  };

export const requestAccess = async (
  payload: RequestAccessPayload,
): Promise<string> => {
  try {
    const response = (await fetch(requestAccessApi, {
      method: 'POST',
      data: payload,
    })) as RequestAccessResponse;

    if (!response.success) {
      throw new Error(response.message);
    }
    return response.message;
  } catch (error) {
    showToast(getErrorMessage(error), false);
    return '';
  }
};

export const getEntityDetails = async (entityId: string) => {
  if (!entityId) return;
  const res = (await fetch(
    getEntityDetailsApi(entityId),
  )) as EntityDetailsResponse;
  return res.data;
};

export const getApprovalEntityActions = async (id: number) => {
  if (!id) return allowedEntityActionFallback;
  try {
    const response = (await fetch(getEntityActionsApi, {
      method: 'GET',
      queryParams: { entity_id: id, history_required: false },
    })) as EntityAllowedActionsResponse;
    return {
      allowedActions: response.allowed_actions,
    };
  } catch (error) {
    showToast((error as Error).message, false);
    return allowedEntityActionFallback;
  }
};

export const allowedEntityActionFallback: {
  allowedActions: string[];
} = { allowedActions: [] };

export const performApprovalEntityAction = async (
  data: ApprovalEntityActionPayload,
) => {
  if (!data.entity_id) return '';
  try {
    const response = (await fetch(performApprovalEntityActionApi, {
      method: 'POST',
      data,
    })) as EntityActionResponse;
    if (response.is_error) throw new Error(response.message);

    return response.message;
  } catch (error) {
    showToast((error as Error).message, false);
    return '';
  }
};
